export type ProductArticleSource = {
    sku: string;
    platform?: string | null;
};

const normalizeValue = (value: string | null | undefined): string => (value || '').trim();

export const formatProductArticleWithPlatform = (sku: string, platform?: string | null): string | null => {
    const normalizedSku = normalizeValue(sku);
    if (!normalizedSku) {
        return null;
    }

    const normalizedPlatform = normalizeValue(platform);
    if (!normalizedPlatform) {
        return normalizedSku;
    }

    return `${normalizedSku}-${normalizedPlatform}`;
};

export const collectUniqueProductArticles = (products: ProductArticleSource[]): string[] => {
    const uniqueArticles = new Set<string>();

    for (const product of products) {
        const article = formatProductArticleWithPlatform(product.sku, product.platform);
        if (article) {
            uniqueArticles.add(article);
        }
    }

    return Array.from(uniqueArticles);
};
